<template>
  <div class="user-list">
    <div class="search-bar flex">
      <div class="left">
        <el-input
          v-model="searchParam.keyword_search"
          placeholder="输入要搜索的内容"
          clearable
          @clear="getList"
        ></el-input>
        <el-select v-model="searchParam.type" placeholder="题型" clearable @clear="getList">
          <el-option label="单选" value="1"></el-option>
          <el-option label="多选" value="2"></el-option>
          <el-option label="实操" value="3"></el-option>
        </el-select>
        <el-select v-model="searchParam.subject_tip_uuid" placeholder="请选择" clearable @change="getList">
          <el-option v-for="item in subjectTipList" :key="item.uuid" :label="item.name" :value="item.uuid"> </el-option>
        </el-select>

        <el-button type="primary" @click="getList('clear')">查询</el-button>
      </div>
      <div class="right">
        <el-button v-if="isteacher" type="primary" @click="isShowBindModal = true">绑定科目</el-button>
        <el-button v-if="isteacher" type="primary" @click="updateExamQuestion">刷新题库</el-button>
        <el-button v-if="isteacher" @click="toDetail()">新建题目</el-button>
      </div>
    </div>

    <div class="m-subject f-flex f-flex-aligm-center" style="margin-bottom: 10px">
      <span style="margin-right: 10px">已绑定科目</span>
      <div class="m-list">
        <el-tag
          class="m-item"
          v-for="(item, index) in examSubjectList"
          :key="index"
          closable
          style="margin-right: 4px"
          @close="handleDelSubject(item)"
        >
          {{ item.name }}
        </el-tag>
      </div>
    </div>

    <div class="table">
      <el-table v-loading="loading" :data="tableData" border style="width: 100%">
        <el-table-column type="index" label="序号" width="120px"> </el-table-column>

        <el-table-column prop="type" label="题型" width="120px">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 1">单选</span>
            <span v-if="scope.row.type === 2">多选</span>
            <span v-if="scope.row.type === 3">实操</span>
          </template>
        </el-table-column>
        <el-table-column prop="title" label="问题"> </el-table-column>
        <el-table-column prop="subject_tips" label="科目" width="120px">
          <template slot-scope="scope">
            {{ scope.row.subject_tips.map((v) => v.name).join(",") }}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="280">
          <template slot-scope="scope">
            <el-button class="mid-blue" @click="toDetailEdit(scope.row)">编辑</el-button>

            <el-button class="mid-red" @click="deleteItem(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 60, 100]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog title="题库列表" :visible.sync="showUserDialog">
      <div style="display: flex; margin-bottom: 10px">
        <el-input v-model="listQuery2.keyword_search" placeholder="搜索题库" clearable @clear="getSelList"></el-input>
        <el-button @click="getSelList">查询</el-button>
      </div>

      <el-table
        ref="seltable"
        :data="tableData2"
        height="40vh"
        :row-key="getRowKey"
        @selection-change="handlePushUserSelectionChange"
      >
        <el-table-column type="selection" width="55" :reserve-selection="true"> </el-table-column>

        <el-table-column property="title" label="标题"></el-table-column>
        <el-table-column property="type" label="题型"></el-table-column>
      </el-table>

      <!--   <div class="select">
                已选用户：<span v-for="(item,i) in pushUserList">{{ item.username }} <i class="el-icon-close" @click="removeItem(i)"></i> </span>
            </div> -->
      <div class="page">
        <pagination
          v-show="total2 > 0"
          small
          :total="total2"
          :page.sync="listQuery2.page_index"
          :limit.sync="listQuery2.page_size"
          :page-sizes="[10, 20, 50, 100, 200]"
          @pagination="getSelList"
        />
      </div>
      <div class="footer" style="text-align: center">
        <el-button type="primary" :loading="pushLoading" @click="toPush"> 确定 </el-button>
        <el-button @click="cancelPush">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="绑定科目" :visible.sync="isShowBindModal" center width="600px">
      <el-form ref="ruleForm" :model="form" label-position="left" label-width="100px" class="add-form">
        <el-form-item label="科目" prop="name">
          <el-select v-model="form.subject_tip_ids" placeholder="请选择" clearable multiple style="width: 100%">
            <el-option v-for="item in subjectTipList" :key="item.uuid" :label="item.name" :value="item.uuid">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowBindModal = false">取 消</el-button>
        <el-button type="primary" @click="handleBindSubject()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  subjectList,
  delSubject,
  editPaper,
  paperSubjectList,
  addPaperSubject,
  delPaperSubject,
  subjectTipList,
  getExamSubjectList,
  bindExamSubject,
  updateExamQuestion,
} from "@/api/edu.js";
import { mixin } from "@/mixins/pagination.js";
import Utils from "@/jslibs/utils";
import Pagination from "@/components/Pagination";
export default {
  components: { Pagination },
  mixins: [mixin],
  data() {
    return {
      loading: false,
      teacherList: [],
      searchParam: {
        keyword_search: "",
        status: "2",
        start_time: "",
        end_time: "",
        subject_tip_uuid: "",
      },
      subjectTipList: [], // 科目列表
      tableData: [],
      pushCouponId: null,
      showUserDialog: false,
      pushUserList: [],
      pushLoading: false,
      listQuery2: {
        page_index: 1,
        page_size: 2,
        keyword_search: "",
        current_page: 1,
        total: 0,
      },
      tableData2: [],
      selList: [],
      total2: 0,
      listQuery: {
        page_index: 1,
        page_size: 10,
      },
      examSubjectList: [], // 试卷绑定的科目列表
      isShowBindModal: false, // 是否显示绑定科目弹窗
      form: {
        subject_tip_ids: [],
      },
    };
  },
  computed: {
    isteacher() {
      const g = Utils.getCookie("X-Access-Group");
      return g != 927 && g != 952;
    },
  },
  mounted() {
    const row = this.$route.query;
    this.pushCouponId = row.uuid;
    this.getList();
    this.getSelList();
    this.getSubjectTipList();
    this.getExamSubjectList();
  },
  methods: {
    // 获取科目列表
    async getSubjectTipList() {
      const res = await subjectTipList({ page_index: 1, page_size: 999 });
      this.subjectTipList = res.data;
    },
    // 获取试卷关联科目
    async getExamSubjectList() {
      const res = await getExamSubjectList({ uuid: this.$route.query.uuid });
      this.examSubjectList = res;
      this.form.subject_tip_ids = res.map((v) => v.uuid);
    },
    // 试卷绑定科目
    async handleBindSubject(ids) {
      const subject_tip_ids = ids || this.form.subject_tip_ids;
      const res = await bindExamSubject({
        uuid: this.$route.query.uuid,
        subject_tip_ids: JSON.stringify(subject_tip_ids),
      });
      if (!res) return;
      this.getExamSubjectList();
      this.isShowBindModal = false;
      this.$message.success(ids ? "解绑成功" : "绑定成功");
    },
    // 删除绑定科目
    handleDelSubject(item) {
      this.$confirm("取消关联后题目不会被删除，刷新科目时将不会再刷新该科目数据", "是否取消关联科目", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          const ids = this.examSubjectList.filter((v) => v.uuid != item.uuid).map((v) => v.uuid);
          this.handleBindSubject(ids);
        })
        .catch(() => {});
    },
    // 更新试卷题目
    async updateExamQuestion() {
      const res = await updateExamQuestion({ uuid: this.$route.query.uuid });
      if (!res) return;
      this.getList();
    },

    getRowKey(row) {
      return row.uuid;
    },
    toAdd(row) {
      console.log(row);
      this.$router.push({
        path: "/offline-detail",
        query: row,
      });
    },
    toDetail(row) {
      console.log(row);
      const self = this;
      const param = {
        uuid: this.$route.query.uuid,
        page_index: this.listQuery.page_index,
        page_size: this.listQuery.page_size,
        all: 1,
      };
      console.log(param);
      this.loading = true;
      paperSubjectList(param).then((res) => {
        console.log("++++++++++++++++");
        console.log(res, "res.data");
        self.loading = false;
        if (res instanceof Array) {
          self.selList = res;
          self.pushUserList = res;
        }
        self.showUserList(row);
      });

      // this.$router.push({
      //     path: '/sel-subject',
      //     query: { ...row, paper_uuid: this.$route.query.uuid }
      // })
      // this.$router.push({
      //     path: '/topic-add',
      //     query: { ...row, paper_uuid: this.$route.query.uuid }
      // })
    },
    toDetailEdit(row) {
      this.$router.push({
        path: "/topic-add",
        query: { ...row, paper_uuid: this.$route.query.uuid },
      });
    },
    showUserList(row) {
      this.showUserDialog = true;
      this.actrow = row;
      // this.pushCouponId = row.id;
      this.getSelList(1);
    },
    handlePushUserSelectionChange(val) {
      this.selList = val;
      this.pushUserList = val;
      console.log(val, "handlePushUserSelectionChange");
    },
    getSelList(sel = 0) {
      console.log("getSelList=====");
      console.log(sel, "sel");
      const param = { ...this.listQuery2 };
      this.loading = true;
      const self = this;
      const tmpArr = self.pushUserList;
      console.log(tmpArr, "已选列表");
      subjectList(param).then((res) => {
        this.loading = false;
        console.log(res, "res");
        if (res.data instanceof Array) {
          self.tableData2 = res.data;
          self.total2 = res.total;
          // 手动选中高亮
          console.log("手动选中高亮");
          res.data.forEach((row) => {
            console.log(row.uuid, "row.uuid");
            tmpArr.forEach((item, index) => {
              console.log(row.uuid + "-" + item.uuid, "row.uuid-item.uuid");
              if (item.uuid == row.uuid) {
                console.log("选中一次", row);
                self.$refs.seltable.toggleRowSelection(row);
              }
            });
          });
        }
      });
    },

    setTop(row) {},
    xiajia(row) {},
    deleteItem(row) {
      this.$confirm("确定要移除该题目吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delPaperSubject(row.id).then((res) => {
            if (res) {
              this.$message.success("成功");
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    async getList(type) {
      // console.log(type, "=====")
      if (type == "clear") {
        this.page_index = 1;
      }
      const param = {
        uuid: this.$route.query.uuid,
        page_index: this.listQuery.page_index,
        page_size: this.listQuery.page_size,
        ...this.searchParam,
      };
      console.log(param);
      this.loading = true;
      const res = await paperSubjectList(param);
      this.loading = false;
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      }
    },

    cancelPush() {
      this.pushUserList = [];
      this.showUserDialog = false;
    },
    toPush() {
      if (this.pushUserList.length === 0) {
        this.$message({
          type: "error",
          message: "至少选择一个推送的用户",
        });
        return;
      }
      this.pushLoading = true;
      console.log(this.pushUserList, "选择的用户");
      addPaperSubject({
        paper_uuid: this.pushCouponId,
        user_uuids: this.pushUserList.map((it) => {
          return it.uuid;
        }),
      }).then((res) => {
        this.pushLoading = false;
        if (res) {
          this.$message.success("成功");
          this.showUserDialog = false;
        }
        this.getList();
      });
      // pushCoupon({
      //     coupon_id: this.actrow.coupon_id,
      //     user_uuids: this.pushUserList.map(it => { return it.uuid })
      // }).then(res => {
      //     this.pushLoading = false;
      //     if (res) {
      //         this.$message.success('成功')
      //         this.showUserDialog = false;
      //     }
      // })

      // TODO : 推送接口对接
    },
  },
};
</script>

<style scoped="scoped">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
</style>
